export const RESET_STEP = '@step/ResetStep'
export const INCREASE_STEP = '@step/AddStep'
export const UPDATE_STEP = '@step/UpdateStep'
export const DECREASE_STEP = '@step/DecreaseStep'
